// extracted by mini-css-extract-plugin
export default {"container2":"Kalendarz_container2__fvJ4A","main":"Kalendarz_main__XaSEH"};